import { defineComponent as _defineComponent } from 'vue'
import Icon from '@/client/components/_atoms/Icon.vue'
import InDmAvatar from '@/client/components/_atoms/in_dm_avatar'

interface Props {
  pictureUrl: string | null
  screenName: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmHeader',
  props: {
    pictureUrl: null,
    screenName: null
  },
  setup(__props: any) {



return { __sfc: true,Icon, InDmAvatar }
}

})